import { simReducer } from './simulationReducer';

const simulationReducer = simReducer('SOCIAL_SECURITY_', ['distribution']);

const initialState = {
  fetched: false,
  data: null,
  lifetimeEstimates: {},
  benefitEstimates: {},
  benefitTypes: {},
  optimalAges: {},
  simulation: undefined,
  _default_spec: null,
};

export default (state = initialState, action) => {
  let uiState = {};
  switch (action.type) {
    case 'SOCIAL_SECURITY_MODULE_FETCHED':
      if (action.payload) {
        return Object.assign({}, state, {
          fetched: true,
          data: action.payload,
        });
      } else {
        return Object.assign({}, state, {
          fetched: true,
          data: null,
        });
      }
    case 'SOCIAL_SECURITY_LIFETIME_ESTIMATES_FETCHED':
      return Object.assign({}, state, {
        lifetimeEstimates: Object.assign({}, state.lifetimeEstimates, { [action.holder]: action.payload }),
        benefitTypes: Object.assign({}, state.benefitTypes, {
          [action.holder]: action.payload.benefits_types_by_age,
        }),
      });
    case 'SOCIAL_SECURITY_BENEFIT_ESTIMATES_FETCHED':
      return Object.assign({}, state, {
        benefitEstimates: Object.assign({}, state.benefitEstimates, action.payload),
      });
    case 'SOCIAL_SECURITY_OPTIMAL_AGES_FETCHED':
      return Object.assign({}, state, {
        optimalAges: Object.assign({}, state.optimalAges, action.payload),
      });
    case 'SOCIAL_SECURITY_SIMULATION_STARTED':
    case 'SOCIAL_SECURITY_SIMULATION_FINISHED':
      return Object.assign({}, state, { simulation: simulationReducer(state.simulation, action) });
    default:
      return state;
  }
};
